<script setup>
import { toasts, dismissToast } from "../lib/toasts"
import { t } from "../lib/i18n"
</script>

<template>
  <!-- Регион живой всегда (даже пустой) — иначе скринридер не озвучит первое сообщение. -->
  <div class="toasts" role="region" :aria-label="t('toast.region')">
    <Transition name="toast" mode="out-in">
      <div
        v-if="toasts[0]"
        :key="toasts[0].id"
        class="toast"
        :class="`toast-${toasts[0].type}`"
        :role="toasts[0].type === 'alert' ? 'alert' : 'status'"
      >
        <span class="dot" aria-hidden="true" />
        <p class="text">{{ toasts[0].text }}</p>
        <button
          v-if="toasts[0].type === 'alert'"
          type="button"
          class="close"
          :aria-label="t('toast.close')"
          @click="dismissToast(toasts[0].id)"
        >
          <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path
            d="M6 6l12 12M18 6L6 18"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          /></svg>
        </button>
      </div>
    </Transition>
  </div>
</template>

<style scoped>
.toasts {
  position: fixed;
  top: var(--sp-5);
  right: var(--sp-5);
  z-index: 80;
  display: flex;
  justify-content: flex-end;
  max-width: min(420px, calc(100vw - 2 * var(--sp-5)));
  pointer-events: none;
}
.toast {
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 240px;
  box-sizing: border-box;
  padding: 13px 16px;
  background: var(--bubble-bg);
  color: var(--bubble-text);
  border-radius: var(--r-md);
  box-shadow: var(--shadow-lg);
  font-family: var(--font-ui);
  font-size: 0.875rem;
  font-weight: 600;
}
.dot { width: 8px; height: 8px; border-radius: 50%; flex: none; background: var(--bubble-success); }
.toast-alert { background: var(--bubble-danger-bg); }
.toast-alert .dot { background: var(--bubble-danger); }
.text { margin: 0; flex: 1; line-height: 1.45; }
.close {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin: -4px -6px -4px 0;
  border: none;
  border-radius: var(--r-sm);
  background: none;
  color: var(--bubble-text);
  opacity: .75;
  cursor: pointer;
  transition: opacity .18s ease;
}
.close:hover { opacity: 1; }
.close:focus-visible { opacity: 1; outline-color: var(--bubble-text); }

.toast-enter-active, .toast-leave-active { transition: opacity .18s ease, transform .18s ease; }
.toast-enter-from, .toast-leave-to { opacity: 0; transform: translateY(-8px); }

@media (max-width: 639px) {
  .toasts { top: var(--sp-4); left: var(--sp-4); right: var(--sp-4); max-width: none; }
  .toast { width: 100%; min-width: 0; }
}
</style>
